/**
 * axios를 통한 요청 헤더에 accept-encoding: gzip을 추가합니다.
 * @param {AxiosInstance} axios
 */
module.exports = function install_axios_compress(axios) {
  if (axios.extension_compress) {
    return;
  }
  axios.extension_compress = true;

  axios.interceptors.request.use(config => {
    if (config.headers == null) {
      config.headers = {}
    }
    config.headers['accept-encoding'] = 'gzip'
    return config;
  });
};
